<!-- UNIVAPLAT-2994: OTP settings history modal -->
<div class="modal-dialog modal-dialog-centered admin-modal">
    <div class="modal-content">
        <div class="modal-header">
            <h1 class="modal-title fs-5" data-testid="otp-history-title">
                <i class="bi bi-clock-history me-1"></i>
                OTP settings history
            </h1>
        </div>
        <div class="modal-body">
            <p class="mb-3" *ngIf="userName">
                User: <strong data-testid="otp-history-user-name">{{ userName }}</strong>
            </p>

            <!-- error state: backend message already surfaced via toastr; inline fallback here -->
            <div class="alert alert-danger mb-0" *ngIf="error" data-testid="otp-history-error">
                The OTP settings history could not be loaded.
            </div>

            <!-- empty state -->
            <div class="alert alert-info mb-0" *ngIf="!loading && !error && entries.length === 0"
                 data-testid="otp-history-empty">
                No OTP settings history.
            </div>

            <!-- success state: populated table, newest-first as returned by the API -->
            <div class="table-responsive" *ngIf="!loading && !error && entries.length > 0">
                <table class="table table-sm align-middle mb-0" data-testid="otp-history-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Prev. status</th>
                            <th>New status</th>
                            <th>Static OTP</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entry of entries" data-testid="otp-history-row">
                            <td data-testid="otp-history-date">{{ entry.changedAt | date:'dd/MM/yyyy HH:mm' }}</td>
                            <td data-testid="otp-history-prev-status">{{ modeLabel(entry.previousMode) }}</td>
                            <td data-testid="otp-history-new-status">{{ modeLabel(entry.newMode) }}</td>
                            <td data-testid="otp-history-static-code">{{ entry.staticCode || '-' }}</td>
                            <td data-testid="otp-history-reason">{{ entry.reason || '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-dark" (click)="modal.close()"
                    data-testid="otp-history-close">Close</button>
        </div>
    </div>
</div>
<!-- loading state -->
<spinner *ngIf="loading"></spinner>
